<template>
  <div class="apd" :class="{ 'apd--mobile': isMobile }">
    <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb />

    <!-- 主体区域num1 -->
    <!-- 主体区域num1 -->
<el-row type="flex" justify="space-between" class="row-bg">
  <!-- 卡片1：用户信息 -->
  <el-col :span="5">
    <div class="info-card">
      <div class="card-icon"><i class="el-icon-user"></i></div>
      <div class="card-content">
        <div class="card-label">{{$t('users.用户名')}}</div>
        <div class="card-value">{{this.$store.state.print.goodsForeNo.username}}</div>
        <div class="card-sub">
          <span class="badge" :class="{ 'is-admin': admin === $t('users.是') }">{{admin}}</span>
          <span>{{$t('users.是否是管理员')}}</span>
        </div>
      </div>
    </div>
  </el-col>

  <!-- 卡片2：设备与余额 -->
  <el-col :span="5">
    <div class="info-card">
      <div class="card-icon"><i class="el-icon-s-data"></i></div>
      <div class="card-content">
        <div class="stat-row">
          <div class="stat-item">
            <div class="stat-value">{{famlsdata.meter_count}}</div>
            <div class="stat-label">{{$t('users.设备总数量')}}</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{famlsdata.meter_not_owing_count}}</div>
            <div class="stat-label">{{$t('users.余额数量')}}</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{famlsdata.meter_not_owing_money}}</div>
            <div class="stat-label">{{$t('users.总剩余额')}}</div>
          </div>
        </div>
      </div>
    </div>
  </el-col>

  <!-- 卡片3：欠费信息 -->
  <!-- 卡片3：欠费信息 -->
<el-col :span="5">
  <div class="info-card">
    <div class="card-icon"><i class="el-icon-warning-outline"></i></div>
    <div class="card-content">
      <div class="stat-row">
        <div class="stat-item">
          <div class="stat-value warning">
            {{famlsdata.meter_owing_count}}
            <span class="view-btn" @click="goToArrearagePage">{{$t('users.查看')}}</span>
          </div>
          <div class="stat-label">{{$t('users.当前欠费数量')}}</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{famlsdata.meter_owing_money}}</div>
          <div class="stat-label">{{$t('users.总欠费额')}}</div>
        </div>
      </div>
    </div>
  </div>
</el-col>

  <!-- 卡片4：快捷入口 -->
  <!-- 卡片4：快捷入口 -->
<el-col :span="5">
  <div class="info-card quick-actions">
    <div class="action-item" @click="caiwu">
      <i class="el-icon-money"></i> 
      <span>{{$t('users.交款退款')}}</span>
    </div>
    <div class="action-item" @click="fako">
      <i class="el-icon-setting"></i>
      <span>{{$t('users.抄收与设置')}}</span>
    </div>
    <div class="action-item" @click="zhangdan">
      <i class="el-icon-document"></i>
      <span>{{$t('users.账单流水')}}</span>
    </div>
  </div>
</el-col>
</el-row>

    <!-- 移动端 -->
    <div type="flex" justify="space-between" class="move-row">
      <div class="move-meis">
        <span>{{$t('users.是否是管理员')}}:{{admin}}</span>
        <span>{{$t('users.设备总数量')}}:{{famlsdata.meter_count}}</span>
      </div>
      <div class="move-meis">
        <span>{{$t('users.余额数量')}}:{{famlsdata.meter_not_owing_count}}</span>
        <span>{{$t('users.总剩余额')}}:{{famlsdata.meter_not_owing_money}}</span>
      </div>
      <div class="move-meis">
        <span>{{$t('users.当前欠费数量')}}:{{famlsdata.meter_owing_count}}</span>
        <span>{{$t('users.总欠费额')}}:{{famlsdata.meter_owing_money}}</span>
      </div>
    </div>

    <!-- 主题区域num2 -->
    <div class="num2">
      <!-- nums--1 -->
      <el-row type="flex" justify="space-between" class="row-num2">
        <el-col :span="12">
          <div class="nums">
            <div class="stxbtn">
              <div><span style="color: #364064">{{$t('users.已结算用水量统计')}}</span></div>
              <div>
                <el-button @click="datr()" ref="datrs">{{$t('users.按月')}}</el-button>
                <el-button @click="dayto()" ref="daytos">{{$t('users.按日')}}</el-button>
              </div>
            </div>
            <div class="intus">
              <Histogram v-if="rrty" :hDataArrs="xDataArr" :is-mobile="isMobile"/>
              <HomeMonth v-if="ttyu" :yDataArrs="yDataArrs" :is-mobile="isMobile"/>
            </div>
          </div>
        </el-col>

        <!-- nums--2 异常告警 -->
        <el-col :span="12" class="row-num2-1">
          <div class="nums2-1">
            <span class="alarm-title">{{$t('users.异常告警')}}</span>
            <span class="alarm-dot"></span>
          </div>
          <div class="nums2-2">
            <el-table
              v-show="!isMobile"
              :data="tableData"
              :header-cell-style="{ textAlign: 'center', background: '#FFF6D8', color: '#8A6A16', fontWeight: '600' }"
              :cell-style="{ textAlign: 'center', background: '#FFFDF5' }"
              highlight-current-row
              style="width: 100%"
              height="261px">
              <el-table-column type="index" :label="$t('users.序号')" width="50"></el-table-column>
              <el-table-column property="meter_id" :label="$t('users.水表编号')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="username" :label="$t('users.用户名称')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="address" :label="$t('users.位置')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="valve" width="80" :label="$t('users.阀门状态')"></el-table-column>
              <el-table-column property="warn_type" width="80" :label="$t('users.异常原因')"></el-table-column>
              <el-table-column>
                <template slot-scope="scope" >
                  <el-button size="mini" style="margin-right: -10px;" @click="handleEdit(scope.row)">{{$t('users.查看')}}</el-button>
                  <el-button size="mini" @click="handleDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-table
              v-show="isMobile"
              class="alarm-table-mobile"
              :data="tableData"
              :header-cell-style="{ textAlign: 'center', fontSize: '13px', padding: '6px 0', background: '#FFF6D8', color: '#8A6A16', fontWeight: '600' }"
  :cell-style="{ textAlign: 'center', fontSize: '13px', padding: '6px 0', background: '#FFFDF5' }"
  highlight-current-row
              style="width: 100%"
              :max-height="alarmTableMobileMaxHeight">
              <el-table-column property="meter_id" width="110"  :label="$t('users.水表编号')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="username" :label="$t('users.用户名称')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="address" :label="$t('users.位置')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column property="valve"  :label="$t('users.阀门状态')"></el-table-column>
              <el-table-column property="warn_type" :label="$t('users.异常原因')"></el-table-column>
              <el-table-column>
                <template slot-scope="scope" >
                  <el-button size="mini" style="margin-right: -10px;" @click="handleEdit(scope.row)">{{$t('users.查看')}}</el-button>
                  <el-button size="mini" @click="handleDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>

      <!-- nums--3 -->
      <el-row type="flex" justify="space-between" class="row-num3">
        <el-col :span="12" class="pie-section-col">
          <div class="nums-zhi">{{$t('users.本月账务统计数据')}}</div>
          <HomeLine :is-mobile="isMobile"/>
          <div class="nums-ben">
            <div class="benyue">{{$t('users.本月')}}</div>
            <div class="payment-info">
              <div class="payment-item" :style="$i18n.locale === 'en' ? {fontSize: '12px'} : {}">
                <span>{{$t('users.微信缴费金额')}}:</span>
                <span>{{famlsdata.total_wechat_pay_money}}</span>
              </div>
              <div class="payment-item" :style="$i18n.locale === 'en' ? {fontSize: '12px'} : {}">
                <span>{{$t('users.业务售水金额')}}:</span>
                <span>{{famlsdata.total_pay_type1_money}}</span>
              </div>
              <div class="payment-item" :style="$i18n.locale === 'en' ? {fontSize: '12px'} : {}">
                <span>{{$t('users.优惠售水金额')}}:</span>
                <span>{{famlsdata.total_pay_type2_money}}</span>
              </div>
              <div class="payment-item" :style="$i18n.locale === 'en' ? {fontSize: '12px'} : {}">
                <span>{{$t('users.系统结转金额')}}:</span>
                <span>{{famlsdata.total_pay_type3_money}}</span>
              </div>
              <div class="payment-item" :style="$i18n.locale === 'en' ? {fontSize: '12px'} : {}">
                <span>{{$t('users.平台退费金额')}}:</span>
                <span>{{famlsdata.total_returned_money}}</span>
              </div>
            </div>
          </div>
        </el-col>

        <!-- nums--4 -->
        <el-col :span="12" class="row-num3-1">
          <div class="nums-4-1">
            <div class="nums-4-1-0" style="color: #4A5372">{{$t('users.用户余额不足告警')}}</div>
            <div class="nums2-2">
              <el-table
                v-show="!isMobile"
                :data="anceinfo"
                :header-cell-style="{textAlign: 'center'}"
                :cell-style="{ textAlign: 'center' }"
                style="width: 100%"
                height="180px">
                <el-table-column type="index" :label="$t('users.序号')" width="50"></el-table-column>
                <el-table-column property="pay_id" :label="$t('users.缴费编号')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="meter_id" :label="$t('users.水表编号')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="balance" :label="$t('users.余额')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="username" :label="$t('users.用户名称')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="address" :label="$t('users.地址')" :show-overflow-tooltip="true"></el-table-column>
              </el-table>

              <el-table
                v-show="isMobile"
                class="balance-table-mobile"
                :data="anceinfo"
                :header-cell-style="{ textAlign: 'center', padding: '4px 0' }"
                :cell-style="{ textAlign: 'center', padding: '4px 0' }"
                style="width: 100%"
                :max-height="balanceTableMobileMaxHeight">
                <el-table-column property="pay_id"  :label="$t('users.缴费编号')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="meter_id" width="130" :label="$t('users.水表编号')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="balance" :label="$t('users.余额')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="username" :label="$t('users.用户名称')" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="address" :label="$t('users.地址')" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </div>

            <div class="feye" :class="{ 'feye--mobile': isMobile }">
              <el-pagination
                :small="isMobile"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="famliSorry.pagenum"
                :page-sizes="[20, 40, 60, 80, 100]"
                :page-size="famliSorry.pagesize"
                :layout="paginationLayout"
                :pager-count="isMobile ? 5 : 7"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 消息通知 -->
    <div class="news" v-show="hide">
      <div class="NoX">
        <span>{{$t('header.公告')}}</span>
        <i class="el-icon-close" @click="Xhinbtn"></i>
      </div>
      <div class="taebe">
        <el-table
          :data="newsTable"
          style="width: 100%"
          :height="isMobile ? undefined : '250'"
          :max-height="isMobile ? newsTableMobileMaxHeight : undefined">
          <el-table-column prop="message" :label="$t('header.公告')" width="350"></el-table-column>
          <el-table-column prop="create_time" :label="$t('header.发布时间')" width="200"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Histogram from '../../components/Echarts/HomeHistogram'
import HomeMonth from '../../components/Echarts/HomeMonth'
import HomeLine from '../../components/Echarts/HomeLine'

export default {
  components: { Histogram, HomeMonth, HomeLine },
  data () {
    return {
      hide: true,
      userfamDrte: null,
      yDataArrs: [],
      xDataArr: [],
      admin: null,
      project_name: null,
      rrty: false,
      ttyu: true,
      tableData: [{
        meter_id: null,
        username: null,
        address: null,
        valve: null,
        warn_type: null
      }],
      famlis: {
        token: null,
        insufficient_balance: true,
        pagenum: 1,
        pagesize: 20
      },
      famliSorry: {
        token: null,
        balance_below: 1,
        pagenum: 1,
        pagesize: 20
      },
      famlsdata: {
        meter_count: null,
        meter_online_count: null,
        meter_owing_count: null,
        project_address: null,
        project_name: null,
        user_count: null,
        return_sum: null,
        water_sum: null,
        pay_sum: null,
        water_money_sum: null
      },
      anceinfo: [],
      total: null,
      pieData: [],
      wxfans: {},
      ptfans: {},
      noties: {
        token: null
      },
      newsTable: [],
      isMobile: false
    }
  },
  computed: {
    paginationLayout () {
      return this.isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'
    },
    alarmTableMobileMaxHeight () {
      if (this.tableData.length <= 5) {
    return undefined
  }
      return this.tableAdaptiveMaxHeight(this.tableData, { max: 261, min: 92, row: 34, header: 40 })
    },
    balanceTableMobileMaxHeight () {
      if (this.anceinfo.length <= 5) {
    return undefined
  }
      return this.tableAdaptiveMaxHeight(this.anceinfo, { max: 220, min: 92, row: 34, header: 40 })
    },
    newsTableMobileMaxHeight () {
      return this.tableAdaptiveMaxHeight(this.newsTable, { max: 280, min: 100, row: 40, header: 40 })
    }
  },
  created () {
    console.log(this.$store.state.print.goodsForeNo, 'vuex')
    this.famliSorry.token = this.$store.state.print.goodsForeNo.token
    this.famlis.token = this.$store.state.print.goodsForeNo.token
    this.project_name = this.$store.state.print.goodsForeNo.project_name

    if (this.$store.state.print.goodsForeNo.is_superuser !== false) {
      this.admin = this.$t('users.是')
    } else {
      this.admin = this.$t('users.否')
    }

    this.Balance()
    this.Exception()
    this.bansData()
    this.Xiaoxin()

    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 768
    }
  },
  mounted () {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    tableAdaptiveMaxHeight (list, { max, min, row, header }) {
      const n = Array.isArray(list) ? list.length : 0
      const rows = Math.max(n, 1)
      const h = header + rows * row
      return Math.min(max, Math.max(min, h))
    },
    checkMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    goToArrearagePage () {
      if (this.famlsdata.meter_owing_count >= 1) {
        this.$router.push({ path: '/Parameter', query: { owingStatus: 1 } })
      } else {
        this.$message({
          message: '当前没有欠费设备',
          type: 'warning'
        })
      }
    },
    Xiaoxin () {
      this.noties.token = this.$store.state.print.goodsForeNo.token
      this.$api.lonig.notifys(this.noties).then((res) => {
        console.log(res, '消息')
        if (res.data.status === 'success') {
          this.newsTable = res.data.data
          if (res.data.total === 0) {
            this.hide = false
          }
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
    },
    Xhinbtn () {
      this.hide = false
    },
    caiwu () {
      this.$router.push({ path: '/accountMent' })
    },
    fako () {
      this.$router.push({ path: '/Parameter' })
    },
    zhangdan () {
      this.$router.push({ path: '/summary' })
    },
    bansData () {
      this.$api.users.paymentProportion(this.famlis).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '饼图首页')
          this.famlsdata = res.data
          this.yDataArrs = res.data.per_month_flow_use
          this.xDataArr = res.data.per_day_flow_use
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    Balance () {
      this.$api.waterMeter.meterdatas(this.famliSorry).then((res) => {
        console.log(res, '余额信息1')
        this.anceinfo = res.data.data
        this.total = res.data.total
      })
    },
    Exception () {
      this.$api.users.Exceptions(this.famlis).then((res) => {
        console.log(res)
        this.tableData = res.data.data
      })
    },
    handleEdit (row) {
      console.log(row)
      this.userfamDrte = row
      this.$router.push({ path: '/fileDetails', query: { project_id: this.famlis.project_id, obj: this.userfamDrte } })
    },
    handleDelete (row) {
      console.log(row)
      this.$confirm('此操作将永久删除该告警信息, 此操作不可逆，请谨慎操作！！！是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          token: this.$store.state.print.goodsForeNo.token,
          id: row.id
        }
        this.$api.users.deleteMeterWarning(params).then((res) => {
          if (res.data.status === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.Exception()
          } else if (res.data.status === 'error') {
            this.$message.error(res.data.message)
          }
        }).catch((error) => {
          console.error('删除失败:', error)
          this.$message.error('删除失败，请稍后重试')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    datr () {
      this.$refs.datrs.$el.style.backgroundColor = '#744DFE'
      this.$refs.datrs.$el.style.color = '#fff'
      this.$refs.daytos.$el.style.backgroundColor = '#fff'
      this.$refs.daytos.$el.style.color = '#744DFE'
      this.rrty = false
      this.ttyu = true
    },
    dayto () {
      this.$refs.daytos.$el.style.backgroundColor = '#744DFE'
      this.$refs.daytos.$el.style.color = '#fff'
      this.$refs.datrs.$el.style.backgroundColor = '#fff'
      this.$refs.datrs.$el.style.color = '#744DFE'
      this.rrty = true
      this.ttyu = false
    },
    handleSizeChange (newSize) {
      console.log(newSize, 'q')
      this.famliSorry.pagesize = newSize
      this.Balance()
    },
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.famliSorry.pagenum = newPage
      this.Balance()
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;

  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 75px;
    padding: 4px 0;

    .yai {
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }

    ::v-deep .el-breadcrumb__item {
      margin-left: 0px;
    }
  }
}

// 主体区域num1 —— 四张卡片统一配色
// 主体区域num1 —— 现代数据卡片
.row-bg {
  padding: 1.5rem 2rem;
  gap: 20px;
// 将 el-col-5 宽度由 20.83333% 改为 24%
::v-deep .el-col-5 {
    width: 24%;
  }

  .info-card {
    height: 8rem;
    border-radius: 12px;
    background: linear-gradient(135deg, #7A5CFF 0%, #A88BFF 100%);
    box-shadow: 0 8px 20px rgba(122, 92, 255, 0.22);
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 1.2rem;
    position: relative;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 14px 28px rgba(122, 92, 255, 0.35);
    }

    .card-icon {
      font-size: 2.6rem;
      margin-right: 1rem;
      opacity: 0.9;
      flex-shrink: 0;
    }

    .card-content {
      flex: 1;
      min-width: 0;
    }

    .card-label {
      font-size: 0.8rem;
      opacity: 0.8;
      margin-bottom: 0.2rem;
    }

    .card-value {
      font-size: 1.4rem;
      font-weight: 600;
      margin-bottom: 0.2rem;
      word-break: break-all;
      line-height: 1.2;
    }

    .card-sub {
      font-size: 0.75rem;
      opacity: 0.85;
      display: flex;
      align-items: center;
      gap: 0.4rem;
    }

    .badge {
      background: rgba(255, 255, 255, 0.2);
      padding: 1px 6px;
      border-radius: 4px;
      font-size: 0.7rem;
      font-weight: 500;

      &.is-admin {
        background: #FFD666;
        color: #7A5CFF;
      }
    }

    .stat-row {
      display: flex;
      gap: 1.5rem;
      justify-content: space-around;

      .stat-item {
        text-align: center;
        flex: 1;
        min-width: 0;

        .stat-value {
          font-size: 1.5rem;
          font-weight: 600;
          line-height: 1.2;
        }

        .stat-label {
          font-size: 0.72rem;
          opacity: 0.8;
          white-space: nowrap;
          margin-top: 0.2rem;
        }
      }
    }

    .warning {
      color: #FFD666;
    }

    // 欠费卡片里的深色“查看”按钮
.view-btn {
  display: inline-block;
  margin-left: 8px;
  padding: 3px 10px;
  font-size: 0.7rem;
  font-weight: 500;
  background: #4A30B8;
  color: #fff;
  border-radius: 4px;
  line-height: 1.4;
  vertical-align: middle;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #3A2098;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(74, 48, 184, 0.4);
  }
}
  }

 // 快捷入口：横排居中
.quick-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.8rem;

  .action-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 0.6rem 0.3rem;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.15s ease;
    text-align: center;
    min-width: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
    }

    i {
      font-size: 1.3rem;
    }

    span {
      font-size: 0.72rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }
}
}

// 主体区域num2
.num2 {
  padding: 20px 70px 0px 50px;
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .row-num2-1 {
    margin-left: 30px;
  }

  .row-num2 {
    width: 100%;

    .el-col {
      height: 310px;
      border-radius: 9px;
      box-shadow: 3px 3px 12px 0px rgba(228, 228, 228, 0.5);
      border: 1px solid #f2f3f5;

      .stxbtn {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;

        .el-button:nth-child(1) {
          margin-right: 30px;
          font-size: 15px;
          color: #fff;
          background-color: #744DFE;
        }

        .el-button:nth-child(2) {
          margin-right: 30px;
          font-size: 15px;
          color: #744DFE;
          background-color: #EDE8FE;
        }
      }

      .nums2-1 {
        padding: 10px 0px 0px 10px;
      }
    }
  }

  // 异常告警：黄色主题
  .row-num2 .row-num2-1 {
    border: 1px solid #FFE08A;
    background: #FFFDF5;

    .nums2-1 {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      background: linear-gradient(90deg, #FFF3C4 0%, #FFFDF5 100%);
      border-bottom: 1px solid #FFE9A8;
      border-radius: 9px 9px 0 0;

      .alarm-title {
        color: #8A6A16;
        font-weight: 600;
        font-size: 15px;
      }

      .alarm-dot {
        width: 8px;
        height: 8px;
        margin-left: 8px;
        border-radius: 50%;
        background-color: #FFC53D;
        box-shadow: 0 0 0 3px rgba(255, 197, 61, 0.2);
      }
    }
  }

  .row-num3-1 {
    margin-left: 30px;
  }

  .row-num3 {
    margin-top: 20px;
    width: 100%;

    .el-col {
      padding-bottom: 10px;
      border-radius: 9px;
      box-shadow: 3px 3px 12px 0px rgba(228, 228, 228, 0.5);
      border: 1px solid #F2F3F5;
      display: flex;
      position: relative;

      .nums-zhi {
        width: 140px;
        padding: 70px 10px;
        position: absolute;
        font-size: 1rem;
        z-index: 9999;
      }

      .nums-ben {
        bottom: 0px;
        right: 0px;
        width: 9.3rem;
        line-height: 2;
        position: absolute;
        display: flex;
        flex-wrap: wrap;
        color: #364064;
        font-size: 0.9rem;

        .benyue {
          width: 100%;
        }
      }

      .nums-4-1 {
        width: 100%;

        .nums-4-1-0 {
          padding: 10px 0px 0px 10px;
        }
      }
    }
  }
}

.news {
  width: 30%;
  height: 300px;
  bottom: 10px;
  right: 10px;
  z-index: 99999;
  position: absolute;
  background-color: #fff;
  border: 1px solid #364064;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 0 10px #000;

  .NoX {
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #364064;
  }
}

// 移动端样式
.move-row {
  border-top: 1px solid #fff;
  padding: 10px 10px;
  background-color: #364064;

  .move-meis {
    display: flex;
    justify-content: space-between;
    color: #fff;
  }
}

@media (min-width: 768px) {
  .move-row {
    display: none;
  }
}

/* ================================ 
   移动端适配核心修改区 (max-width: 768px) 
   ================================ */
@media (max-width: 768px) {
  .news {
    width: 90%;
    left: 5%;
    right: auto;
    position: fixed;
    bottom: 0px;
    margin: 0 auto;
  }

  .Gnv {
    display: none;
  }

  .row-bg {
    padding: 10px 10px;
    display: none;
  }

  .apd--mobile {
    font-size: 12px;

    .move-row {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 12px 10px;
    }

    .move-meis {
      font-size: 12px;
      line-height: 1.5;
      justify-content: space-between;
      padding: 0 5px;
      
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 48%;
      }
    }

    .stxbtn span {
      font-size: 13px !important;
    }

    .stxbtn .el-button {
      padding: 6px 10px;
      font-size: 12px;
    }

    .nums2-1 span,
    .nums-4-1-0 {
      font-size: 13px !important;
    }

    .intus {
      min-width: 0;
      width: 100%;
      height: auto; /* 改为 auto，让内部图表撑开高度 */
      min-height: 20px; /* 最小高度设为 280px，确保上下有充足空间 */
      overflow: hidden;
    }

    .balance-table-mobile {
      ::v-deep .el-table th .cell,
      ::v-deep .el-table td .cell {
        font-size: clamp(10px, 3.2vw, 12px);
        line-height: 1.35;
      }
    }
  }

  .num2 {
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    /* 强制所有行改为垂直排列 */
    .row-num2, .row-num3 {
      display: flex;
      flex-direction: column;
      margin-top: 0;
      margin-bottom: 0;
      width: 100%;
    }

    /* 强制所有列占满全宽，取消左浮动或边距，增加底部间距 */
    .row-num2 .el-col, .row-num3 .el-col {
      width: 100% !important;
      max-width: 100%;
      flex: 0 0 100%;
      height: auto !important;
      min-height: 220px;
      margin-left: 0 !important;
      margin-top: 10px;
      box-sizing: border-box;
    }

    /* 第一个列不需要上边距 */
    .row-num2 .el-col:first-child, .row-num3 .el-col:first-child {
      margin-top: 0;
    }

    /* 图表区域高度自适应，防止遮挡 */
    .row-num2 .el-col:first-child {
      min-height: 260px;
    }

    /* 异常告警表格与底部卡片高度自适应 */
    .row-num2-1 {
      min-height: auto  !important;
    }

    .row-num3-1 {
      min-height: auto !important;
    }

    /* 账单统计和余额不足告警内部布局调整 */
    .pie-section-col {
      display: flex !important;
      flex-direction: column;
      align-items: stretch;
      min-height: 320px !important;
      position: relative;
      padding-bottom: 10px;
    }

    .pie-section-col .nums-zhi {
      position: static !important;
      width: 100% !important;
      padding: 12px 10px 0 !important;
      z-index: 1;
      font-size: 14px !important;
      font-weight: bold;
    }

    .pie-section-col .nums-ben {
      position: static !important;
      width: 100% !important;
      right: auto !important;
      bottom: auto !important;
      margin-top: 10px;
      padding: 0 10px 10px;
      font-size: 12px;
      line-height: 1.6;
      box-sizing: border-box;
    }

    .pie-section-col .payment-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 10px;
      flex-wrap: nowrap;
      border-bottom: 1px dashed #eee; /* 增加分割线，提升可读性 */
      padding: 4px 0;

      &:last-child {
        border-bottom: none;
      }

      span:first-child {
        flex-shrink: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #666;
      }

      span:last-child {
        flex-shrink: 0;
        font-size: 12px;
        font-weight: 600;
        color: #333;
      }
    }

    /* 表格横向滚动支持，防止撑破屏幕 */
    .nums2-2, .alarm-table-mobile, .balance-table-mobile {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    
    ::v-deep .el-table {
      width: 100% !important;
      table-layout: auto !important;
    }
  }

  /* 分页器居中与紧凑 */
  .feye {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    ::v-deep .el-pagination {
      width: max-content;
      min-width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      row-gap: 6px;
      padding: 4px 0;
    }

    ::v-deep .el-pagination__jump,
    ::v-deep .el-pagination__total,
    ::v-deep .el-pagination__sizes {
      display: none;
    }
  }

  .feye--mobile {
    ::v-deep .el-pagination {
      width: 100%;
      justify-content: center;
      padding: 2px 0;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      min-width: 28px;
      font-size: 12px;
    }
  }
}
</style>